import { Layout } from 'antd';
import type { ReactNode } from 'react';
import { TopNav } from '../components/layout/TopNav';
import styles from './AppLayout.module.css';

const { Content } = Layout;

type AppLayoutProps = {
  children: ReactNode;
};

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <Layout className={styles.appLayout}>
      <TopNav />
      <Content className={styles.content}>
        <div className={styles.contentInner}>{children}</div>
      </Content>
    </Layout>
  );
}
